/* eslint-disable react/jsx-no-target-blank */
import React, { type ReactNode } from "react"
import { AppLinkMui, AppLink } from "@ecom/ui/components/AppLink"
import * as styles from "./howInstallmentWorks.module.scss"

export interface Steps {
  title?: ReactNode
  subtitle?: ReactNode
  clickToolTip?: boolean
  textTooltip?: ReactNode
}

export const DEFAULT_STEPS: Steps[] = [
  {
    title: <>Оформите карту</>,
    subtitle: <>Оставьте заявку и получите карту «Халва» с лимитом до 500&nbsp;000 рублей</>,
  },
  {
    title: <>Покупайте с Халвой</>,
    subtitle: <>Совершайте покупки с картой «Халва», а все проценты за вас оплатит магазин</>,
  },
  {
    title: <>Наслаждайтесь покупкой</>,
    subtitle: <>Вносите комфортный платеж равными частями</>,
  },
]

export const STEPS_PRODUCTS_CATEGORIES = [
  {
    title: <>Оставьте заявку</>,
    subtitle: <>Онлайн за несколько минут </>,
  },
  {
    title: <>Получите карту</>,
    subtitle: <>Доставкой или в отделении банка</>,
  },
  {
    title: <>Активируйте карту</>,
    subtitle: <>Совершив покупку в партнерском магазине</>,
  },
]

export const STEPS_SHUBA: Steps[] = [
  {
    title: (
      <>
        Оформляй{" "}
        <strong>
          {" "}
          карту <br /> «Халва»{" "}
        </strong>
      </>
    ),
  },
  {
    title: (
      <>
        Регистрируйся{" "}
        <strong>
          {" "}
          <br /> в&nbsp;Акции
        </strong>
      </>
    ),
  },
  {
    title: (
      <>
        Совершай покупки от&nbsp;500 рублей в&nbsp;любых <br /> магазинах.{" "}
        <strong>Каждая покупка участвует в розыгрыше</strong>
      </>
    ),
  },
]

export const STEPS_ZOON: Steps[] = [
  {
    title: (
      <>
        <span> Оформите карту «Халва», оставив заявку на данной странице </span>
      </>
    ),
  },
  {
    title: (
      <>
        <span>
          Совершите покупку от 1000 руб. в рассрочку* в магазинах-партнерах в течение 1-го месяца
          после оформления карты
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        <span> Активируйте промокод </span> ZOON
        <span> в мобильном приложении банка. 1 балл = 1 рубль.</span>
      </>
    ),
    subtitle: <></>,
  },
]

export const STEPS_NEDELI_UMNUX_RASSROCHEK: Steps[] = [
  {
    title: (
      <>
        <strong>Активируйте акцию</strong> в&nbsp;мобильном <br className={styles.br1} />
        приложении или&nbsp;на&nbsp;странице акции
      </>
    ),
  },
  {
    title: (
      <>
        <strong>Совершайте покупки</strong> с&nbsp;увеличенной рассрочкой* в&nbsp;категориях,
        указанных выше
      </>
    ),
  },
  {
    title: (
      <>
        <strong>Участвуйте в&nbsp;розыгрыше</strong> кэшбэка до&nbsp;100% (но&nbsp;не&nbsp;более
        30&nbsp;000 баллов; 1&nbsp;балл=1&nbsp;рублю).{" "}
        <AppLink
          className={styles.redLink}
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://halvacard.ru/actions/uvelichennaya-rassrochka-i-keshbek/umnye-nedeli"
        >
          Подробнее
        </AppLink>
      </>
    ),
  },
]

export const STEPS_MAY_TRUD_HALVA: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию{" "}
        <span>
          в мобильном приложении или&nbsp;на&nbsp;
          <AppLinkMui
            href="https://halvacard.ru/actions/all/maj-trud-halva"
            target="_blank"
            underline="always"
            className={styles.linkBlack}
          >
            странице акции
          </AppLinkMui>
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>
          товаров <br className="d-large-block d-sm-none" />
          в&nbsp;магазинах-партнёрах акции и&nbsp;регистрируйте чеки от&nbsp;этих покупок
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите промокод{" "}
        <span>
          {" "}
          на&nbsp;дополнительную рассрочку* и&nbsp;примените его к совершённой покупке. Подробные
          условия{" "}
          <AppLinkMui
            className={styles.linkBlack}
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/actions/all/maj-trud-halva"
            underline="always"
          >
            по&nbsp;ссылке
          </AppLinkMui>
        </span>
      </>
    ),
  },
]

export const STEPS_NEDELI_UMNUX_RASSROCHEK_MEDIA: Steps[] = [
  {
    title: (
      <>
        <strong>Оформите карту</strong> и&nbsp;получите карту доставкой&nbsp;или в&nbsp;отделении
        банка
      </>
    ),
  },
  {
    title: (
      <>
        <strong>Активируйте акцию</strong> в&nbsp;мобильном приложении&nbsp;или на&nbsp;странице
        акции
      </>
    ),
  },
  {
    title: (
      <>
        <strong>Совершайте покупки в&nbsp;рассрочку*</strong> <br className="d-tab-only-none" />
        на&nbsp;12 месяцев и&nbsp;участвуйте в&nbsp;розыгрыше кэшбэка до&nbsp;100%
      </>
    ),
  },
]

export const STEPS_SHAPKA: Steps[] = [
  {
    title: (
      <>
        <strong>Приходи </strong>в наше зимнее отделение в виде огромной шапки (ВДНХ, возле
        «Бурана»)
      </>
    ),
  },
  {
    title: (
      <>
        <strong>Обращайся </strong>к нашему финансовому консультанту для оформления стикера
      </>
    ),
  },
  {
    title: (
      <>
        <strong> Согревайся</strong> вкусным <br className="d-mob-only-none" /> «Халвакао»!
      </>
    ),
  },
]

export const STEPS_PKW: Steps[] = [
  {
    title: (
      <>
        Оформите карту онлайн
        <br />
        <span>
          Получите Халву с лимитом до 500&nbsp;000 ₽ уже завтра <b>не выходя из дома</b>
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Покупайте с Халвой
        <br />
        <span>
          Вы точно найдете <b>всё, что хотите</b> от продуктов и до бытовой техники
          <b> у&nbsp;250&nbsp;000+&nbsp;партнеров</b>
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Наслаждайтесь покупкой
        <br />
        <span>
          Проценты за вас <b>заплатит магазин</b>
        </span>
      </>
    ),
  },
]

export const STEPS_REFIN: Steps[] = [
  {
    subtitle: (
      <>
        <b>
          Погасите свои кредитные карты
          <br />
        </b>
        на сумму до&nbsp;300&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Оплачивайте Халвой ежемесячно </b>от&nbsp;10&nbsp;покупок на&nbsp;общую&nbsp;сумму
        от&nbsp;20&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Наслаждайтесь рассрочкой* </b>на&nbsp;24&nbsp;месяца
      </>
    ),
  },
]

export const STEPS_REFIN_ZADOLZHENNOSTEJ: Steps[] = [
  {
    subtitle: (
      <>
        <b>Объедините</b> все ваши долги в&nbsp;один&nbsp;платеж на&nbsp;24&nbsp;месяца
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Платите</b> равными
        <br />
        ежемесячными платежами
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Наслаждайтесь</b>
        <br />
        рефинансированием
      </>
    ),
  },
]

export const STEPS_REFIN_KREDITNOY_KARTY: Steps[] = [
  {
    subtitle: (
      <>
        <b>
          Погасите свои <br className="d-ld-none" /> кредитные карты
        </b>{" "}
        на&nbsp;сумму до&nbsp;300&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Оплачивайте Халвой ежемесячно</b> от&nbsp;10&nbsp;покупок на&nbsp;общую сумму
        от&nbsp;20&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Наслаждайтесь рассрочкой*</b> на&nbsp;24&nbsp;месяца
      </>
    ),
  },
]

export const STEPS_HALVA: Steps[] = [
  {
    title: (
      <>
        Погасите&nbsp;свои кредиты <br className="d-ld-none" />
        <span>на&nbsp;сумму до&nbsp;300&nbsp;000&nbsp;₽</span>
      </>
    ),
  },
  {
    title: (
      <>
        Оплачивайте&nbsp;Халвой ежемесячно{" "}
        <span>от 5 покупок на общую сумму от &nbsp;10&nbsp;000&nbsp;₽</span>
      </>
    ),
  },
  {
    title: (
      <>
        Наслаждайтесь беспроцентной <br /> рассрочкой* <span>до&nbsp;24&nbsp;месяцев</span>
      </>
    ),
    subtitle: <></>,
  },
]

export const STEPS_REDISIGN_BEZPROCENTOV: Steps[] = [
  {
    title: (
      <>
        <span> Получите карту.</span> В течение <br className="d-sm-none" /> первого месяца
        рассрочка* <span>у всех партнеров</span> – 24 месяца
      </>
    ),
  },
  {
    title: (
      <>
        <span> Оплачивайте&nbsp;Халвой </span> ежемесячно от 5 покупок <span> на общую сумму </span>{" "}
        от&nbsp;10&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    title: (
      <>
        <span> Наслаждайтесь</span> беспроцентной <br /> рассрочкой* до&nbsp;24&nbsp;месяцев
      </>
    ),
    subtitle: <></>,
  },
]

export const STEPS_PKW_REDISIGN: Steps[] = [
  {
    title: (
      <>
        <span> Получите карту.</span> В&nbsp;течение <br className="d-sm-none" /> первого месяца
        рассрочка* <br className="d-sm-none" /> <span>у&nbsp;всех партнеров</span> – 24&nbsp;месяца
      </>
    ),
  },
  {
    title: (
      <>
        <span> Оплачивайте&nbsp;Халвой </span> ежемесячно от&nbsp;5 покупок{" "}
        <span> на&nbsp;общую сумму </span> от&nbsp;10&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    title: (
      <>
        <span>
          {" "}
          Погашайте равными <br className="d-sm-none" /> платежами
        </span>{" "}
        <br className="d-none d-tab-only-block" /> 24&nbsp;месяца
      </>
    ),
    subtitle: <></>,
  },
]

export const STEPS_LENTA: Steps[] = [
  {
    title: (
      <>
        Оформите карту «Халва»
        <span>
          &nbsp;и привяжите ее <br className="d-none d-large-block" /> к&nbsp;
          <AppLink rel="nofollow noopener" target="_blank" href=" https://lenta.com/lentapay/">
            <u>Лента Pay</u>
          </AppLink>{" "}
          в мобильном приложении «Лента»
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершите в любом магазине «Лента» покупку{" "}
        <span>по Халве после оформления карты в период</span>
        &nbsp;с 23.04 по 20.05.2024
      </>
    ),
  },
  {
    title: (
      <>
        Получите 2000 баллов{" "}
        <span>
          на Карту №1 <br className="d-none d-large-block" /> от «Ленты» до 20.06.2024 ( 1 балл ={" "}
          <br className="d-none d-large-block" /> 1 рубль)
        </span>
      </>
    ),
    subtitle: <></>,
  },
]

export const STEPS_NEWYEAR: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию <span>в&nbsp;мобильном приложении или&nbsp;на&nbsp;странице акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>с&nbsp;увеличенной рассрочкой* на&nbsp;12&nbsp;месяцев у&nbsp;партнеров акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Играйте в&nbsp;новогоднюю игру <span>и&nbsp;получайте промокоды на&nbsp;подарки</span>
      </>
    ),
    subtitle: <></>,
  },
]

export const STEPS_STICKER_PAY: Steps[] = [
  {
    title: (
      <>
        Заберите стикер <span> в ближайшем офисе Совкомбанка в течение 10 дней</span>.
      </>
    ),
  },

  {
    title: (
      <>
        Выполните условия{" "}
        <span>
          регулярного шопинга: от&#160;5 покупок на сумму не менее 10&nbsp;000 рублей за месяц.
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Выполняйте этой условие каждый месяц, чтобы </span>стикер оставался бесплатным!
      </>
    ),
  },
]

export const STEPS_KIBERPONEDELNIK: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию{" "}
        <span>
          в&nbsp;мобильном приложении или на{" "}
          <AppLinkMui
            href="https://halvacard.ru/actions/all/keshbek-do-100-za-pokupki"
            target="_blank"
            underline="always"
            className={styles.linkBlack}
          >
            странице акции
          </AppLinkMui>
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>
          в&nbsp;интернет-магазинах партнёров и&nbsp;регистрируйте чеки на сумму от&nbsp;3000₽
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получайте промокоды{" "}
        <span>
          на&nbsp;кэшбэк до&nbsp;100% на онлайн-покупки.{" "}
          <AppLinkMui
            href="https://halvacard.ru/actions/all/keshbek-do-100-za-pokupki"
            target="_blank"
            underline="always"
            className={styles.linkBlack}
          >
            Подробнее
          </AppLinkMui>
        </span>
      </>
    ),
  },
]

export const STEPS_BLACK_FRIDAY_HALVA_MEDIA: Steps[] = [
  {
    title: (
      <>
        Оформите карту{" "}
        <span>
          и&nbsp;активируйте акцию в&nbsp;мобильном приложении или&nbsp;на&nbsp;странице акции
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>
          от&nbsp;5&nbsp;000&nbsp;₽ <br className="d-sm-none d-md-block" />
          в&nbsp;любых магазинах-партнёрах и&nbsp;регистрируйте чеки{" "}
          <br className="d-none d-sm-block d-ld-none" />
          от&nbsp;этих покупок
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Крутите&nbsp;Колесо&nbsp;фортуны{" "}
        <span>
          и&nbsp;получайте рассрочку* до&nbsp;36 месяцев, кэшбэк до&nbsp;30% или&nbsp;скидки
          от&nbsp;партнёров. А&nbsp;также участвуйте в&nbsp;розыгрыше призов*
        </span>
      </>
    ),
  },
]

export const STEPS_GENDER_ACTION_MEDIA: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию
        <span> в&nbsp;мобильном приложении или&nbsp;на&nbsp;странице акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>
          от&nbsp;3&nbsp;000&nbsp;₽ в&nbsp;любых магазинах-партнёрах и&nbsp;регистрируйте чеки{" "}
          <br className="d-none d-sm-block d-ld-none" />
          от&nbsp;этих покупок
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Крутите&nbsp;Колесо <br className="d-none d-sm-block d-md-none" />
        фортуны{" "}
        <span>
          и&nbsp;получайте рассрочку* до&nbsp;36 месяцев, кешбэк до&nbsp;70%. А&nbsp;также
          участвуйте в&nbsp;розыгрыше призов
        </span>
      </>
    ),
  },
]

export const STEPS_GENDER_ACTION: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию{" "}
        <span>
          в&nbsp;мобильном приложении или{" "}
          <AppLinkMui
            href=" https://halvacard.ru/shops/actions/keshbek-do-100-na-podarki-lyubimym"
            target="_blank"
            underline="always"
            className={styles.linkBlack}
          >
            на&nbsp;странице акции
          </AppLinkMui>
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки <span>в&nbsp;любых магазинах партнёров Халвы в&nbsp;период акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Участвуйте в&nbsp;розыгрыше кэшбэка до&nbsp;100%{" "}
        <span> (но не более 50&nbsp;000 баллов. 1&nbsp;балл&nbsp;= 1 руб.)</span>
      </>
    ),
    subtitle: <></>,
  },
]

export const STEPS_PROMOPAGE: Steps[] = [
  {
    title: (
      <>
        Оформите карту «Халва» <br />в период<span>&nbsp;1.05.2024 по 31.12.2024</span>
      </>
    ),
  },
  {
    title: (
      <>
        Активируйте промокод из СМС
        <span>
          &nbsp;и примените его к первой покупке от 3000 заемными средствами в магазинах-партнерах
          из списка: Lamoda, Ozon, Яндекс.Маркет, Мегамаркет
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кэшбэк 500 рублей
        <br />
        <span>он поступит на бонусный счет вашей Халвы </span>
      </>
    ),
  },
]

export const STEPS_PKW_OZON: Steps[] = [
  {
    title: (
      <>
        Оформите карту «Халва» <br />в период<span>&nbsp;с 03.06.2024 по 05.07.2024</span>
      </>
    ),
  },
  {
    title: (
      <>
        Активируйте промокод в мобильном приложении Халвы
        <span>
          &nbsp;и примените его к первой покупке от 3000 заемными средствами в магазинe-партнере
          Ozon
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кэшбэк 500 рублей
        <br />
        <span>он поступит на бонусный счет вашей Халвы </span>
      </>
    ),
  },
]

export const STEPS_PKW_AVIASALES: Steps[] = [
  {
    title: (
      <>
        Оформи карту «Халва» <br />в период<span>&nbsp;с 20.05.2024 по 07.07.2024</span>
      </>
    ),
  },
  {
    title: (
      <>
        Активируйте промокод в мобильном приложении Халвы
        <span>
          &nbsp;и примените его к первой покупке от 3000 заемными средствами в магазинах-партнерах
          из списка: Lamoda, Ozon, Яндекс.Маркет, Мегамаркет
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кэшбэк 500 рублей
        <br />
        <span>он поступит на бонусный счет вашей Халвы </span>
      </>
    ),
  },
]

export const STEPS_24_MESYACA_BEZ_PROCENTOV: Steps[] = [
  {
    title: (
      <>
        Заполните заявку <br className="d-md-none" />
        <span>
          на&nbsp;оформление
          <br className="d-none d-large-block" /> карты рассрочки* «Халва» прямо сейчас
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершите покупки <br className="d-md-none" />
        <span>в&#160;магазинах-партнерах на&nbsp;сумму от&nbsp;1000&nbsp;₽</span>
      </>
    ),
  },
  {
    title: (
      <>
        <span className={styles.toolTipDashed}>Получите до 1000 баллов</span>{" "}
        <br className="d-md-none" />
        <span>
          кешбэка
          <br className="d-none d-large-block" /> на&nbsp;карту рассрочки* «Халва»,
          <br className="d-mob-only-none" /> где&nbsp;1&nbsp;балл=1&nbsp;рубль
        </span>
      </>
    ),
    clickToolTip: true,
    textTooltip: (
      <ul>
        <li>
          1000 баллов, если все <br /> покупки будут за&nbsp;заемные <br /> средства
        </li>
        <li>500 баллов, если будут использоваться свои деньги (полностью или&nbsp;частично)</li>
        <li>Кешбэк начислят в&nbsp;течение 30&nbsp;дней после выполнения всех условий акции</li>
      </ul>
    ),
  },
]

export const STEPS_PKW_BONUS_1500: Steps[] = [
  {
    title: (
      <>
        Оформите карту «Халва» <br />
        <span>
          После получения вам придет промокод
          <br className="d-none d-tab-only-block d-large-block" /> на 1500 баллов
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Активируйте промокод
        <br />
        <span>
          в разделе «Бонусы». Баллы станут доступны при&nbsp;совершении 10&nbsp;покупок
          на&nbsp;общую сумму от&nbsp;20&nbsp;000&nbsp;₽
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Примените баллы <br className="d-none d-tab-only-block" /> на покупку{" "}
        <br className="d-none" />
        <span>
          <br className="d-none d-tab-only-block d-large-block" />
          от 1500 рублей
          <br className="d-none d-tab-only-block" /> в магазинах-партнерах карты «Халва»
        </span>
      </>
    ),
  },
]

export const STEPS_100_CASHBACK: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию <span>в мобильном приложении или на странице акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>в любых магазинах-партнёрах и получайте 100% кэшбэк за них в период акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Накопленные баллы{" "}
        <span>
          обменяйте на сертификат, который предоставляет скидку на покупку в магазинах-партнёрах
          акции.
        </span>
      </>
    ),
  },
]

export const STEPS_BTS_AUTO: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию <br className="d-none d-tab-only-block d-desk-only-block" /> «Готовимся к
        школе с&nbsp;Халвой» <br className="d-none d-tab-only-block" />
        <span>на&nbsp;странице акции или&nbsp;в&nbsp;приложении</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершите 5 покупок <br /> от&nbsp;10 000 ₽ <br className="d-sm-none" />{" "}
        <span>в&nbsp;магазинах-партнерах</span>
      </>
    ),
  },
  {
    title: (
      <>
        Крутите колесо фортуны <br className="d-none d-tab-only-block" />
        <span>и&nbsp;участвуйте в&nbsp;розыгрыше</span>
      </>
    ),
  },
]

export const STEPS_AUTO_PROMO: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию
        <br className="d-none d-tab-only-block d-desk-only-block" />{" "}
        <span>в&nbsp;мобильном приложении или на&nbsp;странице акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки
        <br className="d-ld-none" />{" "}
        <span>с&nbsp;увеличенной рассрочкой* до&nbsp;36&nbsp;месяцев у&nbsp;любых партнеров</span>
      </>
    ),
  },
  {
    title: (
      <>
        Получайте дополнительные промокоды{" "}
        <span>
          на&nbsp;
          <AppLinkMui
            href="https://fortune.halva.games/actions/gotovimsya_k_shkole_s_halvoj"
            target="_blank"
            underline="always"
            className={styles.blackLink}
          >
            промо-странице
          </AppLinkMui>{" "}
          на&nbsp;подарки от&nbsp;Халвы и&nbsp;партнеров
        </span>
      </>
    ),
  },
]

export const STEPS_BACKTOSCHOOL: Steps[] = [
  {
    subtitle: (
      <>
        <b>Активируйте акцию</b>
        <br />в мобильном приложении <br />
        или на странице{" "}
        <AppLink
          style={{ color: "inherit", textDecoration: "underline" }}
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://halvacard.ru/shops/actions/vserossijskij-shkolnyj-keshbek-2025"
        >
          акции
        </AppLink>
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Совершайте покупки</b>
        <br />в любых магазинах партнёров <br />и регистрируйте чеки <br className="d-ld-none" />
        от этих покупок
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Крутите&nbsp;Колесо&nbsp;фортуны</b>
        <br />
        на{" "}
        <AppLink
          style={{ color: "inherit", textDecoration: "underline" }}
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://fortune.halva.games/actions/shkolxnyj_keshbek_2025"
        >
          промо-странице
        </AppLink>{" "}
        и&nbsp;получайте кэшбэк до&nbsp;100%&nbsp;и&nbsp;рассрочку* до&nbsp;36&nbsp;месяцев
      </>
    ),
  },
]

export const STEPS_GETHALVA_BTS: Steps[] = [
  {
    subtitle: (
      <>
        <b>Активируйте акцию</b> в&nbsp;мобильном приложении или на странице акции
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Совершайте покупки</b> в&nbsp;любых магазинах партнёров <br className="d-ld-none" />и
        регистрируйте чеки <br className="d-ld-none" />
        от этих покупок
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Крутите&nbsp;Колесо&nbsp;фортуны</b>
        <br />
        и&nbsp;получайте кешбэк до&nbsp;100% и&nbsp;рассрочку до&nbsp;24&nbsp;месяцев
      </>
    ),
  },
]

export const STEPS_VK_EDUCATION: Steps[] = [
  {
    title: (
      <>
        Оформите&nbsp;карту&nbsp;«Халва»
        <span>
          <br className="d-ld-none" /> в период акции, найдите <br className="d-ld-none" /> промокод
          в мобильном <br className="d-ld-none" /> приложении
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Примените промокод{" "}
        <span>
          <br className="d-none d-tab-only-block" /> к нужной покупке заемными средствами из условий
          акции
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кэшбэк,{" "}
        <span>
          он поступит <br className="d-none d-md-block" /> <br className="d-sm-none" /> на бонусный
          счет вашей Халвы
        </span>
      </>
    ),
  },
]

export const STEPS_HIPPO: Steps[] = [
  {
    title: (
      <>
        Оформите <br className="d-md-none" />
        <span>карту&nbsp;«Халва»</span>
      </>
    ),
  },
  {
    title: (
      <>
        Оплатите парковку{" "}
        <span>
          «HippoParking» картой в&nbsp;период проведения акции с&nbsp; 01.07.2025 по 31.07.2025
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Начислим кэшбэк 20%{" "}
        <span>
          за&nbsp;каждую оплату парковки по&nbsp;Халве, но&nbsp;не&nbsp;более{" "}
          <br className="d-tab-only-none d-ld-none" /> 1 000 баллов
        </span>
      </>
    ),
  },
]

export const STEPS_HIPPO_PARKING: Steps[] = [
  {
    title: (
      <>
        Оформите карту «Халва»{" "}
        <span>
          путем перехода из&nbsp;мобильного приложения «Hippoparking» в&nbsp;период проведения акции
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите промокод и&nbsp;активируйте его.{" "}
        <span>
          Совершите покупку заемными средствами на&nbsp;сумму от&nbsp;2&nbsp;000&nbsp;₽
          в&nbsp;магазине-партнёре Халвы, примените промокод к&nbsp;совершенной покупке
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кешбэк,{" "}
        <span>он поступит на&nbsp;бонусный счет Вашей Халвы (максимум 2&nbsp;000 баллов) </span>
      </>
    ),
  },
]

export const STEPS_BLACK_FRIDAY_HALVA: Steps[] = [
  {
    title: (
      <>
        Оформите карту <span> и&nbsp;активируйте акцию в&nbsp;приложении</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>
          в&nbsp;любых <br className="d-none d-large-block" />
          магазинах-партнерах Халвы
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Радуйтесь покупкам <br />
        <span>
          и&nbsp;выплачивайте сумму <br className="d-none d-large-block" />
          в&nbsp;рассрочку* до&nbsp;24&nbsp;месяцев
        </span>
      </>
    ),
  },
]

export const STEPS_PROCENTY_VERNET_MAGAZIN: Steps[] = [
  {
    title: <>Оформите карту «Халва»</>,
  },
  {
    title: (
      <>
        Совершайте покупки <br />
        <span>в&nbsp;магазинах-партнерах Халвы</span>
      </>
    ),
  },
  {
    title: (
      <>
        Радуйтесь покупкам <br />
        <span>
          и&nbsp;выплачивайте их стоимость <br className="d-none d-large-block" />
          в&nbsp;рассрочку* до&nbsp;24&nbsp;месяцев
        </span>
      </>
    ),
  },
]

export const STEPS_BLACK_FRIDAY: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию <br className="d-ld-none" />
        <span>в мобильном приложении или на&nbsp;странице акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки <span>в&nbsp;любых магазинах-партнерах</span>
      </>
    ),
  },
  {
    title: (
      <>
        Наслаждайтесь <br className="d-md-none" /> беспроцентной рассрочкой*{" "}
        <span>на&nbsp;24&nbsp;месяца</span>
      </>
    ),
  },
]

export const STEPS_NEWYEAR_MEDIA: Steps[] = [
  {
    title: (
      <>
        Оформите карту <span>и&nbsp;активируйте акцию в&nbsp;приложении</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки <br className="d-none d-md-block" />{" "}
        <span> в&nbsp;любых магазинах-партнерах Халвы</span>
      </>
    ),
  },
  {
    title: (
      <>
        Играйте в&nbsp;новогоднюю игру <span>и&nbsp;получайте промокоды на&nbsp;подарки</span>
      </>
    ),
  },
]

export const STEPS_NEWYEAR_HALVA: Steps[] = [
  {
    title: (
      <>
        Активируйте акцию <span>в&nbsp;мобильном приложении или на&nbsp;странице акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки{" "}
        <span>
          {" "}
          с&nbsp;увеличенной рассрочкой* на&nbsp;10&nbsp;месяцев в&nbsp;любых магазинах партнеров
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Играйте в&nbsp;новогоднюю игру <span>и&nbsp;получайте промокоды на&nbsp;подарки</span>
      </>
    ),
  },
]

export const STEPS_RASSROCHKA_S_HALVOI = [
  {
    title: (
      <>
        Оставьте заявку <br />
        <span>Онлайн за несколько минут</span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите карту <br />
        <span>Доставкой или в&nbsp;отделении банка</span>
      </>
    ),
  },
  {
    title: (
      <>
        Активируйте карту <br />
        <span>Совершив покупку в&nbsp;партнерском магазине</span>
      </>
    ),
  },
]

export const STEPS_MEDIA = [
  {
    title: (
      <>
        Оставьте заявку. <br />
        <span>Онлайн за несколько минут</span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите&nbsp;карту.{" "}
        <span>
          Доставкой
          <br /> или в&nbsp;отделении банка
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Активируйте акцию <span> в&nbsp;мобильном приложении</span>
      </>
    ),
  },
]

export const STEPS_KESHBECK_20 = [
  {
    title: (
      <>
        Оформите карту «Халва» <br />
        <span>и установите мобильное приложение «Халва-Совкомбанк»</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершите в Пятерочке первую покупку <span>от 700 рублей до&nbsp;30.09.25</span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кэшбэк 20% <span>но&nbsp;не&nbsp;более 2000 баллов</span>
      </>
    ),
  },
]

export const STEPS_KESHBECK_30 = [
  {
    title: (
      <>
        Оформите карту «Халва» <br />
        <span>и установите мобильное приложение «Халва-Совкомбанк»</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершите первую покупку{" "}
        <span>
          по&nbsp;карте Халва в&nbsp;магазине Пятерочка от&nbsp;700&nbsp;рублей до&nbsp;30.12
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кэшбэк 30%{" "}
        <span>за&nbsp;совершенную покупку, но&nbsp;не&nbsp;более 2000&nbsp;баллов</span>
      </>
    ),
  },
]

export const STEPS_KESHBECK_2000 = [
  {
    title: (
      <>
        Оформите карту «Халва» <br />
        <span>и установите мобильное приложение «Халва-Совкомбанк»</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершите первую покупку{" "}
        <span>
          по&nbsp;карте Халва в&nbsp;магазине Пятерочка на&nbsp;сумму от&nbsp;2000&nbsp;рублей
          до&nbsp;30.12
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кэшбэк 2000 баллов <span>за&nbsp;совершенную покупку на&nbsp;карту «Халва»</span>
      </>
    ),
  },
]

export const STEPS_DOBROE_COFFEE = [
  {
    title: (
      <>
        Ваша карта — старт. <br />
        <span>Оформив ее, вы запустите новый источник помощи</span>
      </>
    ),
  },
  {
    title: (
      <>
        Совкомбанк — помощник в добрых делах.
        <br />
        <span>Выделяет деньги на покупку кофейных автоматов</span>
      </>
    ),
  },
  {
    title: (
      <>
        Аппарат — постоянная помощь.
        <br />
        <span>Регулярно приносит средства для семей героев и спортсменов</span>
      </>
    ),
  },
]

export const BEST_BENEFITS: Steps[] = [
  {
    title: (
      <>
        Оформите карту «Халва»{" "}
        <span>
          путем перехода из&nbsp;мобильного приложения или&nbsp;сайта «Bestbenefits» в&nbsp;период
          проведения акции
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите промокод и&nbsp;активируйте его.{" "}
        <span>
          Совершите покупку заемными средствами на&nbsp;сумму от&nbsp;1&nbsp;000&nbsp;₽
          в&nbsp;магазине-партнёре Халвы, примените промокод к&nbsp;совершенной покупке
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кешбэк,{" "}
        <span>он поступит на&nbsp;бонусный счет Вашей Халвы (максимум 1&nbsp;000 баллов) </span>
      </>
    ),
  },
]

export const STEPS_BLACK_FRIDAY_HALVA_2025: Steps[] = [
  {
    title: (
      <>
        Оформите карту{" "}
        <span>
          {" "}
          и&nbsp;активируйте{" "}
          <AppLink
            className={styles.blackLink}
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/actions/all/chernaya-pyatnica-halva"
          >
            акцию
          </AppLink>{" "}
          в&nbsp;мобильном приложении или&nbsp;на&nbsp;странице акции
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки <br className={styles.br} />
        <span>
          от&nbsp;5&nbsp;000&nbsp;₽ <br className="d-none d-large-block" /> в&nbsp;любых
          магазинах-партнерах и&nbsp;
          <AppLink
            className={styles.blackLink}
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://fortune.halva.games/actions/chernaya_pyatnica_2025"
          >
            регистрируйте чеки
          </AppLink>{" "}
          от&nbsp;этих&nbsp;покупок
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Крутите Колесо фортуны <br className={styles.br} />
        <span>
          и&nbsp;получайте рассрочку* до 36 месяцев, кэшбэк до&nbsp;30% скидки от&nbsp;партнёров. А
          также участвуйте в&nbsp;розыгрыше призов*
        </span>
      </>
    ),
  },
]

export const CB_PROMO: Steps[] = [
  {
    title: (
      <>
        Оформите карту «Халва» <span>на&nbsp;этой странице в&nbsp;период проведения акции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите промокод и&nbsp;активируйте его.{" "}
        <span>
          Совершите покупку заемными средствами на&nbsp;сумму от&nbsp;1&nbsp;000&nbsp;₽
          в&nbsp;магазине-партнёре Халвы, примените промокод к&nbsp;совершенной покупке
        </span>
      </>
    ),
  },
  {
    title: (
      <>
        Получите кешбэк,{" "}
        <span>он поступит на&nbsp;бонусный счет Вашей Халвы (максимум 1&nbsp;000 баллов) </span>
      </>
    ),
  },
]

export const STEPS_SCHOOL_ACTION: Steps[] = [
  {
    subtitle: (
      <>
        <b>Активируйте акцию</b> в&nbsp;мобильном приложении или на{" "}
        <AppLink
          style={{ color: "inherit", textDecoration: "underline" }}
          rel="nofollow noopener"
          target="_blank"
          href="https://halvacard.ru/actions/all/bolshie-peremeny-s-keshbekom-i-rassrochkoj"
        >
          странице акции
        </AppLink>{" "}
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Совершайте покупки</b> в&nbsp;любых магазинах партнёров <br className="d-ld-none" />и
        регистрируйте чеки <br className="d-ld-none" />
        от этих покупок
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Крутите&nbsp;Колесо&nbsp;фортуны</b>
        <br />
        и&nbsp;получайте кешбэк до&nbsp;100% и&nbsp;рассрочку до&nbsp;24&nbsp;месяцев**
      </>
    ),
  },
]

export const STEPS_SMART_WEEKS: Steps[] = [
  {
    subtitle: (
      <>
        <b>Активируйте акцию</b> в&nbsp;мобильном приложении или на{" "}
        <AppLink
          style={{ color: "inherit", textDecoration: "underline" }}
          rel="nofollow noopener"
          target="_blank"
          href="https://halvacard.ru/actions/all/umnye-nedeli-keshbek-100"
        >
          странице акции
        </AppLink>{" "}
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Совершайте покупки</b> в&nbsp;акционных категориях <br className="d-ld-none" />и
        регистрируйте чеки <br className="d-ld-none" />
        от&nbsp;2&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    subtitle: (
      <>
        <b>Получайте промокоды </b>
        <span>
          на&nbsp;кешбэк до&nbsp;100% или на рассрочку до 18 мес. на&nbsp;покупки.{" "}
          <AppLinkMui
            href="https://halvacard.ru/actions/all/umnye-nedeli-keshbek-100"
            target="_blank"
            underline="always"
            className={styles.linkBlack}
          >
            Подробнее
          </AppLinkMui>
        </span>
      </>
    ),
  },
]
